export default "__VITE_ASSET__BxXs6oDG__"